import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';

import Filters from './Table/Filters';
import columns from './Table/columns';
import data from './Table/data';

import Statistcs from './Statistics';

import { useContext } from './Context';

export default function Table() {
  const { dispatch, actions, state } = useContext();

  const [keyword, setKeyword] = useState('');
  const [filterType, setFilterType] = useState(null);
  const [filterStatus, setFilterStatus] = useState(null);
  const [filterDateStart, setFilterDateStart] = useState(null);
  const [filterDateEnd, setFilterDateEnd] = useState(null);

  useEffect(() => {
    actions.load(dispatch);
  }, []);

  const filteredData = data(state.invoices, keyword, filterType, filterStatus, filterDateStart, filterDateEnd) || [];

  return (
    <>
      <Statistcs invoices={filteredData} />
      <div className="ibox-content mt20">
        <Filters
          keyword={keyword}
          setKeyword={setKeyword}
          filterType={filterType}
          setFilterType={setFilterType}
          filterStatus={filterStatus}
          setFilterStatus={setFilterStatus}
          filterDateStart={filterDateStart}
          setFilterDateStart={setFilterDateStart}
          filterDateEnd={filterDateEnd}
          setFilterDateEnd={setFilterDateEnd}
        />
        <div className="datatable-style">
          <DataTable
            title=""
            columns={columns}
            data={filteredData}
            noDataComponent={(
              <div className="mt20">
                {state.invoices == null
                  ? 'Please, wait ...'
                  : 'No matching records found'}
              </div>
            )}
            persistTableHead
            pagination
            paginationComponentOptions={{
              selectAllRowsItem: true,
              selectAllRowsItemText: 'All',
            }}
          />
        </div>
      </div>
    </>
  );
}
